import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './contact.css';
import Notification from '../../components/notification.js';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [notification, setNotification] = useState(null);

  // JSON-LD structured data for Contact page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact InspiraPix",
    "description": "Get in touch with InspiraPix team for questions, support, or feedback about our AI-powered image generation platform.",
    "mainEntity": {
      "@type": "Organization",
      "name": "InspiraPix",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "email": "contact@inspirapix.com"
      }
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('http://localhost:4000/api/contact/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setNotification({
        type: 'success',
        message: 'Message sent successfully! We will get back to you soon.'
      });
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setNotification({
        type: 'error',
        message: 'Failed to send message. Please try again.'
      });
    }
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <>
      <Helmet>
        <title>Contact InspiraPix | Get in Touch With Us</title>
        <meta name="description" content="Contact InspiraPix for questions, support, or feedback about our AI-powered image generation platform. We're here to help you create amazing art." />
        <meta name="keywords" content="contact InspiraPix, support, feedback, help, AI art generation" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div className="contact-container">
        <div className="contact-content">
          <section className="contact-hero">
            <h1>Contact Us</h1>
            <p className="hero-subtitle">
              Have questions or feedback? We'd love to hear from you.
            </p>
          </section>

          <div className="contact-grid">
            <section className="contact-form-section">
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-button">
                  Send Message
                </button>
              </form>
            </section>

            <section className="contact-info-section">
              <div className="contact-info">
                <h2>Get in Touch</h2>
                <p>
                  We aim to respond to all inquiries within 24 hours during business days.
                  For immediate assistance, please check our FAQ section.
                </p>
                <div className="contact-details">
                  <div className="contact-item">
                    <h3>Email</h3>
                    <p><a href="mailto:contact@inspirapix.com">contact@inspirapix.com</a></p>
                  </div>
                  <div className="contact-item">
                    <h3>Support Hours</h3>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        {notification && (
          <Notification
            type={notification.type}
            message={notification.message}
            onClose={handleCloseNotification}
          />
        )}
      </div>
    </>
  );
};

export default Contact; 